/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import { FrozenAssetList } from './components';

export const FrozenAssets = () => {
  return (
    <Routes>
      <Route path="/" element={<FrozenAssetList />} />
    </Routes>
  );
};
